import { useState } from 'react'
import { X } from 'lucide-react'
import { ChatAttachmentChip } from './ChatAttachmentChip'
import type { ChatAttachment } from '@/types/chat'

interface ChatAttachmentThumbnailProps {
  attachment: ChatAttachment
  previewUrl: string
  onRemove?: () => void
}

export function ChatAttachmentThumbnail({ attachment, previewUrl, onRemove }: Readonly<ChatAttachmentThumbnailProps>) {
  const [previewFailed, setPreviewFailed] = useState(false)

  if (previewFailed) {
    return <ChatAttachmentChip attachment={attachment} onRemove={onRemove} />
  }

  return (
    <span className="relative inline-flex shrink-0" data-testid="chat-attachment-thumbnail">
      <img
        src={previewUrl}
        alt={attachment.fileName}
        title={attachment.fileName}
        onError={() => setPreviewFailed(true)}
        className="h-10 w-10 rounded-md border object-cover"
      />
      {onRemove && (
        <button
          type="button"
          onClick={onRemove}
          className="absolute -right-1.5 -top-1.5 rounded-full border bg-background p-0.5 text-muted-foreground shadow-sm hover:text-foreground"
          aria-label={`Remove ${attachment.fileName}`}
        >
          <X className="h-3 w-3" />
        </button>
      )}
    </span>
  )
}
